import { Form } from 'react-bootstrap';

function RequestorListTrainingCompleted({ selectedTrainingStatuses, trainingStatus, id, onClick }) {
    const isChecked = selectedTrainingStatuses.includes(trainingStatus);
  
    return (
      <Form.Group controlId={id}>
      <Form.Check 
        type="checkbox" 
        label={trainingStatus ? "Yes" : "No"}
        checked={isChecked} 
        onChange={() => onClick(trainingStatus)} 
      />
    </Form.Group>
    );
  }
  
  export default RequestorListTrainingCompleted;
  